import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header card-header-jaya" }
const _hoisted_3 = { class: "card-toolbar my-auto" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  key: 0,
  class: "stepper stepper-pills stepper-column d-flex flex-wrap justify-content-center",
  id: "kt_stepper_example_basic",
  ref: "newDiagnosticStepper"
}
const _hoisted_6 = { class: "d-flex justify-content-center flex-row-fluid pb-15" }
const _hoisted_7 = { class: "stepper-nav flex-wrap" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-item mx-2 current pb-5\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">C</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Création</h3></div></div>", 1)
const _hoisted_9 = {
  key: 0,
  class: "stepper-item mx-2 pb-5",
  "data-kt-stepper-element": "nav"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">T</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Type</h3></div>", 3)
const _hoisted_13 = [
  _hoisted_10
]
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-item mx-2 pb-5\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">E</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Exploitation</h3></div></div><div class=\"stepper-item mx-2 pb-0\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">P</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Période</h3></div></div>", 2)
const _hoisted_16 = {
  class: "form col-12 col-lg-9 ps-lg-15",
  id: "kt_stepper_example_basic_form"
}
const _hoisted_17 = { class: "mb-5" }
const _hoisted_18 = {
  class: "flex-column current",
  "data-kt-stepper-element": "content"
}
const _hoisted_19 = { class: "fv-row mb-10" }
const _hoisted_20 = { class: "form-check form-check-custom form-check-solid mb-5" }
const _hoisted_21 = { class: "flex-column" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "form-check-label fw-bolder text-dark fs-6 ms-0 me-3 mb-1" }, " Diagnostic vierge ", -1)
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "form-check form-check-custom form-check-solid mt-2" }
const _hoisted_26 = { class: "flex-column" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "form-check-label fw-bolder text-dark fs-6 ms-0 me-3 mb-1" }, " A partir d'un diagnostic déjà terminé ", -1)
const _hoisted_28 = { class: "text-muted" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "fv-plugins-message-container mt-5" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = {
  key: 0,
  class: "fv-row mb-10"
}
const _hoisted_33 = {
  key: 0,
  class: "flex-column",
  "data-kt-stepper-element": "content"
}
const _hoisted_34 = { class: "fv-row mb-10" }
const _hoisted_35 = { class: "form-check form-check-custom form-check-solid mb-5" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "flex-column" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-check-label fw-bolder text-dark fs-6 ms-0 me-3 mb-1" }, " Diagnostic réel "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, [
    /*#__PURE__*/_createElementVNode("strong", null, " Un diagnostic réel porte sur une exploitation existante. ")
  ])
], -1)
const _hoisted_37 = { class: "form-check form-check-custom form-check-solid mt-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "flex-column" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-check-label fw-bolder text-dark fs-6 ms-0 me-3 mb-1" }, " Diagnostic simulé "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, [
    /*#__PURE__*/_createElementVNode("strong", null, " Un diagnostic simulé ne représente pas un cas réel. "),
    /*#__PURE__*/_createTextVNode(" Vous pouvez vous en servir pour estimer l'impact d'actions à venir, pour faire des essais ou simplement pour prendre en main l'outil. ")
  ])
], -1)
const _hoisted_39 = { class: "fv-plugins-message-container mt-5" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = {
  class: "flex-column",
  "data-kt-stepper-element": "content"
}
const _hoisted_42 = {
  key: 0,
  class: "text-center fs-5"
}
const _hoisted_43 = {
  class: "flex-column",
  "data-kt-stepper-element": "content"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "form-check form-check-custom form-check-solid mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-column" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "form-check-label fw-bolder text-dark fs-6 ms-0 me-3 mb-1" }, " A quelle période ce diagnostic fait-il référence ? "),
    /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, [
      /*#__PURE__*/_createElementVNode("strong", null, " Ce choix définira l'année culturale du diagnostic. "),
      /*#__PURE__*/_createTextVNode(" Avec plusieurs diagnostics à différentes dates, vous pourrez voir l'évolution temporelle de vos résultats. ")
    ])
  ])
], -1)
const _hoisted_45 = { class: "fv-plugins-message-container mt-5" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { class: "d-flex flex-stack" }
const _hoisted_48 = { class: "me-2" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Valider ", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Veuillez patienter "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_title_jaya = _resolveComponent("card-title-jaya")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DiagnosticsList = _resolveComponent("DiagnosticsList")!
  const _component_ExploitationsList = _resolveComponent("ExploitationsList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_card_title_jaya, {
        "duotune-icon": "layouts/lay001",
        title: "Création d'un diagnostic",
        subTitle: "Informations générales"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "btn btn-primary btn-sm svg-icon svg-icon-white",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'new-exploitation' })))
        }, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" }),
          _createTextVNode(" Nouvelle exploitation ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.canCreateDiagnostic)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                (_ctx.canDiagnosticBeReal)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_13))
                  : _createCommentVNode("", true),
                _hoisted_14
              ])
            ]),
            _createElementVNode("form", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, [
                      _createVNode(_component_Field, {
                        modelValue: _ctx.fromScratch,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fromScratch) = $event)),
                        class: "form-check-input me-3",
                        type: "radio",
                        name: "fromScratch",
                        value: true
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", _hoisted_23, [
                          _createTextVNode(" Vous devrez remplir les niveaux de tous les facteurs du diagnostic. En plus, il faudra choisir à quelle exploitation le diagnostic est lié"),
                          (_ctx.canDiagnosticBeReal)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, ", le type de diagnostic (réel ou simulé), "))
                            : _createCommentVNode("", true),
                          _createTextVNode(" et la période que vous souhaitez évaluer. ")
                        ])
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_25, [
                      _createVNode(_component_Field, {
                        modelValue: _ctx.fromScratch,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fromScratch) = $event)),
                        class: "form-check-input me-3",
                        disabled: !_ctx.canCreateDiagnosticFromExisting,
                        type: "radio",
                        name: "fromScratch",
                        value: false
                      }, null, 8, ["modelValue", "disabled"]),
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("div", _hoisted_28, [
                          _createTextVNode(" Les niveaux des facteurs seront pré-remplis. L'exploitation liée "),
                          (_ctx.canDiagnosticBeReal)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, ", le type de diagnostic, "))
                            : _createCommentVNode("", true),
                          _createTextVNode(" et la période d'évaluation seront pré-remplis, mais vous pouvez les modifier dans les étapes suivantes. ")
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_ErrorMessage, { name: "fromScratch" })
                      ])
                    ])
                  ]),
                  (!_ctx.fromScratch)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createVNode(_component_DiagnosticsList, { onNewSelectionDiagnostic: _ctx.setDiagnosticChoice }, null, 8, ["onNewSelectionDiagnostic"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.canDiagnosticBeReal)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("label", _hoisted_35, [
                          _createVNode(_component_Field, {
                            modelValue: _ctx.newDiagnostic.is_real,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newDiagnostic.is_real) = $event)),
                            class: "form-check-input me-3",
                            type: "radio",
                            name: "isReal",
                            disabled: !_ctx.canDiagnosticBeReal,
                            value: true,
                            onChange: _ctx.checkMaxDateEvaluated
                          }, null, 8, ["modelValue", "disabled", "onChange"]),
                          _hoisted_36
                        ]),
                        _createElementVNode("label", _hoisted_37, [
                          _createVNode(_component_Field, {
                            modelValue: _ctx.newDiagnostic.is_real,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newDiagnostic.is_real) = $event)),
                            class: "form-check-input me-3",
                            type: "radio",
                            name: "isReal",
                            value: false
                          }, null, 8, ["modelValue"]),
                          _hoisted_38
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createVNode(_component_ErrorMessage, { name: "isReal" })
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_41, [
                  (_ctx.newDiagnostic.exploitation === -1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, " Veuillez sélectionner une exploitation "))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ExploitationsList, {
                    ref: "exploitationList",
                    selectedExploitation: _ctx.newDiagnostic.exploitation_id,
                    onNewSelectionFactor: _ctx.setExploitationChoice
                  }, null, 8, ["selectedExploitation", "onNewSelectionFactor"])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.editingDateEvaluated,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editingDateEvaluated) = $event)),
                    class: "form-control form-control-solid text-center",
                    type: "date",
                    max: _ctx.maxDateEvaluated,
                    onChange: _ctx.checkMaxDateEvaluated,
                    name: "dateEvaluated"
                  }, null, 8, ["modelValue", "max", "onChange"]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_ErrorMessage, { name: "dateEvaluated" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light btn-active-light-primary",
                    "data-kt-stepper-action": "previous",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                  }, " Précédent ")
                ]),
                _createElementVNode("div", null, [
                  (_ctx.currentStepIndex === _ctx.totalSteps - 1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary",
                        "data-kt-stepper-action": "submit",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.checkForRecentDiagnostics()))
                      }, _hoisted_51))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-primary",
                        "data-kt-stepper-action": "next",
                        disabled: !_ctx.stepValid,
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args)))
                      }, " Suivant ", 8, _hoisted_52))
                ])
              ])
            ])
          ], 512))
        : (_openBlock(), _createElementBlock("p", _hoisted_53, " Vous n'avez pas d'exploitation sur laquelle réaliser un diagnostic pour le moment. "))
    ])
  ]))
}